module.exports = {
    // live
    apiUrl: 'https://icurious-api-v0.herokuapp.com',

    // local
    // apiUrl: 'http://localhost:3009',
    
    //backdoor temp key
    secretBackdoorKey: '0000'
}